import { KYMW1502Component } from './kymw1502.component';

/**
 * 適用期間指定画面の値を管理するクラス
 *
 * @export KYMW1502Model
 * @class KYMW1502Model
 */
export class KYMW1502Model {

  kymw1502Component: KYMW1502Component;

  vo: any;

  /** 使用開始 指定無し */
  public notDesignateStart = true;
  public notDesignateStartDisabled = false;

  /** 使用開始 受注コード */
  public startOrderCode: string = <string>'';
  public startOrderCodeEnabled = false;

  /** 使用開始　配達企画回 */
  public startDelivCatalogIdDisabled = true;

  /** 使用終了 指定無し */
  public notDesignateEnd = true;
  public notDesignateEndDisabled = false;

  /** 使用終了 受注コード */
  public endOrderCode: string = <string>'';
  public endOrderCodeEnabled = false;

  /** 使用終了　配達企画回 */
  public endDelivCatalogIdDisabled = true;
}
